module.exports = __webpack_public_path__ + "static/img/buyer-program-hero.04de28e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/buyer-listing-details-as-pdf/assets/buyer-program-hero.jpg
// module id = XP6z
// module chunks = 0